module.exports = __webpack_public_path__ + "static/media/TipsQR.755af39b.png";